import { useQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import {
  ApplicantUserPersonalInformationInput,
  ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment,
  Entity,
  ApplicantProfileApplyToEditContainerApplicantUserDocument,
  ApplicantProfileApplyToEditContainerApplicantUserUpdateDocument,
  ApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables,
  ApplicantProfileApplyToEditContainerEntitiesDocument,
} from "../../../../generated";
import { message } from "antd";
import { ProfileApplyToEdit } from "./profile-apply-to-edit";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { useMemo } from "react";

interface ProfileApplyToEditContainerProps {
  data: {
    applicantId: string;
  };
}

const navigateToView = (navigate: ReturnType<typeof useNavigate>) => {
  navigate(location.pathname.replace(/\/[^/]+$/, "/view"));
};

export const ProfileApplyToEditContainer: React.FC<ProfileApplyToEditContainerProps> = (props) => {
  const navigate = useNavigate();

  // Query to get the applicant's applying to data
  const {
    data: applyingToData,
    loading: applyingToLoading,
    error: applyingToError,
  } = useQuery(ApplicantProfileApplyToEditContainerApplicantUserDocument, {
    variables: {
      id: props.data.applicantId,
    },
  });

  // Query to get the entities data
  const { data: entityData, loading: entityLoading, error: entityError } = useQuery(ApplicantProfileApplyToEditContainerEntitiesDocument);

  // Mutation to update the applicant's applying to data
  const [applicantUserUpdate] = useMutation(ApplicantProfileApplyToEditContainerApplicantUserUpdateDocument);

  // Function to handle the save action
  const handleSave = async (data: ApplicantUserPersonalInformationInput) => {
    console.log("data to be updated: ", data);
    const applicantUserUpdateInputData: ApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables = {
      input: {
        id: props.data.applicantId,
        applicantUserDetails: {
          personalInformation: data,
        },
      },
    };
    try {
      const updateResult = await applicantUserUpdate({
        variables: applicantUserUpdateInputData,
      });
      if (updateResult.data?.applicantUserUpdate) {
        message.success("Organization details updated successfully");
        navigateToView(navigate);
      } else {
        message.error("Failed to update organization details");
      }
    } catch (error) {
      message.error(`Error updating organization details`);
    }
  };

  const filteredEntityData = useMemo(() => entityData?.entities?.filter((entity) => entity?.isClient === true) || [], [entityData?.entities]);

  const isEntityArray = (data: unknown): data is Entity[] => Array.isArray(data) && data.every((item) => "entityName" in item && "isClient" in item && "id" in item);

  const entityDataAsserted = isEntityArray(filteredEntityData) ? filteredEntityData : [];

  const handleEditToggle = () => {
    navigateToView(navigate);
  };

  return (
    <ComponentQueryLoader
      loading={applyingToLoading || entityLoading}
      error={applyingToError || entityError}
      hasData={!!applyingToData && !!entityData}
      hasDataComponent={
        <ProfileApplyToEdit
          data={applyingToData?.applicantUser as ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment}
          entities={entityDataAsserted}
          onEditToggle={handleEditToggle}
          onSave={handleSave}
        />
      }
    />
  );
};

